import { render, staticRenderFns } from "./SmallWidget.vue?vue&type=template&id=66b3a9a0&scoped=true&"
import script from "./SmallWidget.vue?vue&type=script&lang=js&"
export * from "./SmallWidget.vue?vue&type=script&lang=js&"
function injectStyles (context) {
  
  var style0 = require("./SmallWidget.vue?vue&type=style&index=0&id=66b3a9a0&scoped=true&lang=css&")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "66b3a9a0",
  null
  ,true
)

export default component.exports